import { auth } from '../lib/firebase';
import { createApiError } from '../lib/usageLimitMessages';
import { safeStringify } from '../lib/utils';

export interface SourceKnowledgeCitation {
  citationId: string;
  sourceId: string;
  sourceName: string;
  sourceType: string;
  url?: string;
  excerpt: string;
  location?: string | null;
}

export interface SourceKnowledgeResponse {
  answer: string;
  citations: SourceKnowledgeCitation[];
  groundingStatus: 'grounded' | 'partially_grounded' | 'insufficient_evidence' | 'conflicting_sources';
  sourceSetId: string;
  sourceIdsUsed: string[];
  modelUsed?: string;
  fallbackUsed?: boolean;
}

export async function askSourceKnowledge(
  sourceSetId: string,
  message: string,
  history: { role: 'user' | 'assistant'; text: string }[] = [],
  organisationId?: string | null
): Promise<SourceKnowledgeResponse> {
  const token = auth.currentUser ? await auth.currentUser.getIdToken() : null;

  if (!token) {
    throw new Error('You must be logged in to use Ask Source.');
  }

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  };

  const scopedOrganisationId = typeof organisationId === 'string' ? organisationId.trim() : '';
  if (scopedOrganisationId) {
    headers['X-Organization-Id'] = scopedOrganisationId;
  }

  const response = await fetch(`/api/source-sets/${sourceSetId}/ask`, {
    method: 'POST',
    headers,
    body: safeStringify({ message, history })
  });

  const envelope = await response.json().catch(() => null);

  if (!response.ok || !envelope?.success) {
    throw createApiError(response, envelope, 'Ask Source failed.');
  }

  return envelope.data;
}
